import { RouteRecordRaw } from "vue-router"
import { CampaignRouteNameEnum } from "@/shared/enums/routes/campaign.enum.ts"
import { AppPermissions } from "@/shared/permissions"

export const campaignsRoutes: RouteRecordRaw[] = [
	{
		path: "/campaigns",
		name: CampaignRouteNameEnum.list,
		component: () => import("@/pages/campaigns/CampaignListPage.vue"),
		meta: {
			title: CampaignRouteNameEnum.list,
			layout: "MainLayout",
			authRequired: true,
			permission: { any: [AppPermissions.CanViewOwnCampaigns, AppPermissions.CanViewSubordinateCampaigns] },
		},
	},
	{
		path: "/campaigns/locations",
		name: CampaignRouteNameEnum.locations,
		component: () => import("@/pages/campaigns/CampaignLocationsPage.vue"),
		meta: {
			title: CampaignRouteNameEnum.locations,
			layout: "MainLayout",
			authRequired: true,
			permission: { any: [AppPermissions.CanCreateCampaign, AppPermissions.CanCreateCampaignForSubordinate] },
		},
	},
	{
		path: "/campaigns/:id",
		name: CampaignRouteNameEnum.item,
		component: () => import("@/pages/campaigns/CampaignItemPage.vue"),
		meta: {
			title: CampaignRouteNameEnum.item,
			layout: "MainLayout",
			authRequired: true,
			permission: { any: [AppPermissions.CanViewOwnCampaigns, AppPermissions.CanViewSubordinateCampaigns] },
		},
	},
	{
		path: "/campaigns/order-details/:order",
		name: CampaignRouteNameEnum.orderDetails,
		component: () => import("@/pages/campaigns/CampaignDetailsPage.vue"),
		meta: {
			title: CampaignRouteNameEnum.orderDetails,
			layout: "MainLayout",
			authRequired: true,
			permission: { any: [AppPermissions.CanCreateCampaign, AppPermissions.CanCreateCampaignForSubordinate] },
		},
	},
	{
		path: "/campaigns/reserved-order-details/:reservedOrder",
		name: CampaignRouteNameEnum.reservedOrderDetails,
		component: () => import("@/pages/campaigns/CampaignReservedDetailsPage.vue"),
		meta: {
			title: CampaignRouteNameEnum.reservedOrderDetails,
			layout: "MainLayout",
			authRequired: true,
			permission: AppPermissions.CanActivateReservedCampaign,
		},
	},
];
